export interface Volume {
  code: string
  name: string
  count: string
  intro: string
  includes: string[]
}

export const volumes: Volume[] = [
  {
    code: '01',
    name: 'Master-Vault de Deportes de Equipo',
    count: '50 sesiones completas',
    intro:
      'Fútbol, básquetbol, voleibol y balonmano con la sesión entera escrita: objetivo, calentamiento, parte principal y vuelta a la calma. Listo para cualquier programa escolar.',
    includes: [
      'Reglas modificadas por nivel',
      'Progresiones pedagógicas',
      'Juegos inclusivos',
    ],
  },
  {
    code: '02',
    name: 'Atletismo, Gimnasia y EF Individual',
    count: '50 sesiones completas',
    intro:
      'Atletismo sin pista reglamentaria, gimnasia en espacios pequeños y acondicionamiento escolar. Todo pensado para la realidad de una escuela con recursos limitados.',
    includes: [
      'Atletismo sin pista reglamentaria',
      'Gimnasia en espacios reducidos',
      'Acondicionamiento por niveles',
    ],
  },
  {
    code: '03',
    name: 'El Tesoro de los Juegos Menores',
    count: '50+ juegos listos para aplicar',
    intro:
      'Juegos cooperativos, carreras de relevos y desafíos grupales. Cero material y máxima inclusión: la solución para días de lluvia o espacios limitados.',
    includes: [
      'Cero material necesario',
      'Máxima inclusión del grupo',
      'Ideal para días de lluvia',
    ],
  },
  {
    code: '04',
    name: 'Toolkit de Evaluación Competencial',
    count: 'Rúbricas listas para usar',
    intro:
      'Evaluación de competencias motrices, actitudinales y conceptuales, con informes listos para las familias y adaptables a cualquier programa oficial.',
    includes: [
      'Rúbricas por competencia',
      'Adaptable a cualquier programa',
      'Informes para familias',
    ],
  },
  {
    code: '05',
    name: 'Tarjetas Visuales de Habilidad',
    count: '120+ tarjetas de técnica',
    intro:
      'Dejas las tarjetas en la clase y los estudiantes aprenden solos. Imágenes del movimiento correcto e incorrecto para cada deporte.',
    includes: [
      'Movimiento correcto vs incorrecto',
      'Una tarjeta por habilidad',
      'Autonomía del estudiante',
    ],
  },
  {
    code: '06',
    name: 'El Planificador Anual Blindado',
    count: 'Plan anual de 36 semanas',
    intro:
      'Tu año escolar ya diseñado: unidades didácticas coherentes, progresiones claras y evaluaciones programadas. Copias, adaptas y enseñas.',
    includes: [
      'Unidades didácticas encadenadas',
      'Progresión motriz por trimestre',
      'Evaluaciones ya calendarizadas',
    ],
  },
]
